import React from 'react';

import Header from './_header';
import Preface from './_preface';
import Strip from './_strip';
import Preorder from './_preorder';
import Bonus from './_bonus';

const OrderView = () => {
  return (
    <>
      <Header />
      <Preface />
      <Strip />
      <Preorder />
      <Bonus />
    </>
  );
}

export default OrderView;
